import React from 'react';

interface Iprops {
  onClose?: (e?: any) => void
  className?: string
}

function CloseBtn(props: Iprops) {
    const {
        onClose,
        className,
    } = props
    return (
        <div
            onClick={onClose}
            className={`absolute flex justify-center items-center self-start cursor-pointer w-[40px] h-[40px] font-[300] text-[40px] rotate-45 text-grey hover:text-black ${className}`}
        >
            +
        </div>
    );
}

export default CloseBtn;
